import { useState } from 'react';
import { theme } from '../../theme';
import { useIsMobile } from '../../hooks/useMediaQuery';

const STATUS_LABELS = { online: 'Online', busy: 'Ocupado', offline: 'Offline' };
const STATUS_COLORS = { online: '#4ade80', busy: '#facc15', offline: '#94a3b8' };

export default function AgentTopBar({ username, status, onStatusChange, onLogout }) {
  const [open, setOpen] = useState(false);
  const isMobile = useIsMobile();

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: isMobile ? '0 0.75rem' : '0 1.5rem', height: '56px',
      backgroundColor: theme.colors.surface,
      borderBottom: `1px solid ${theme.colors.border}`,
      position: 'relative', zIndex: 10, gap: isMobile ? '0.5rem' : 0,
    }}>
      <span style={{ color: theme.colors.primary, fontWeight: 700, fontSize: isMobile ? '0.85rem' : '1rem', whiteSpace: 'nowrap', flexShrink: 0 }}>
      New horizont start
      </span>
      <span style={{ color: theme.colors.textMuted, fontSize: isMobile ? '0.78rem' : '0.9rem', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
        {username}
      </span>
      <div style={{ display: 'flex', gap: isMobile ? '0.5rem' : '1rem', alignItems: 'center', flexShrink: 0 }}>
        <div style={{ position: 'relative' }}>
          <button
            onClick={() => setOpen((o) => !o)}
            style={{
              display: 'flex', alignItems: 'center', gap: '6px',
              background: 'transparent', border: `1px solid ${theme.colors.border}`,
              borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', color: theme.colors.text,
            }}
          >
            <span style={{ width: 8, height: 8, borderRadius: '50%', background: STATUS_COLORS[status], display: 'inline-block' }} />
            {STATUS_LABELS[status]}
          </button>
          {open && (
            <div style={{
              position: 'absolute', top: '110%', right: 0, background: theme.colors.surface,
              border: `1px solid ${theme.colors.border}`, borderRadius: '8px',
              overflow: 'hidden', minWidth: '130px', zIndex: 100,
            }}>
              {['online', 'busy'].map((s) => (
                <button key={s} onClick={() => { onStatusChange(s); setOpen(false); }} style={{
                  display: 'flex', alignItems: 'center', gap: '8px', width: '100%',
                  background: 'transparent', border: 'none', padding: '10px 14px',
                  cursor: 'pointer', color: theme.colors.text, fontSize: '0.9rem',
                }}>
                  <span style={{ width: 8, height: 8, borderRadius: '50%', background: STATUS_COLORS[s], display: 'inline-block' }} />
                  {STATUS_LABELS[s]}
                </button>
              ))}
            </div>
          )}
        </div>
        <button onClick={onLogout} style={{
          background: 'transparent', border: `1px solid ${theme.colors.error}`,
          borderRadius: '6px', padding: '5px 12px', cursor: 'pointer', color: theme.colors.error, fontSize: '0.85rem',
        }}>
          Salir
        </button>
      </div>
    </div>
  );
}
